import React from 'react';
import PropTypes from 'prop-types';
import { FDBox, FDPaper, FDStack } from '@facet-wealth/design';
import fr from 'facet-rest';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import {
  RecurringExpenseItemOverride,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingRecurringExpenses/metaOverrideSet';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { displayErrorMessageWithChecks } from 'Context/SnackbarContext/utils';


function RecurringExpenseItems({ items, RecurringExpenseItemComponent }) {
  const theme = useTheme();
  const { refreshOnboardingStepCollection } = useSurveyContext();
  const { displayErrorMessage } = useSnackbarContext();

  const onDelete = async (item) => {
    try {
      await item.delete();
      await refreshOnboardingStepCollection();
    } catch (err) {
      displayErrorMessageWithChecks(err, displayErrorMessage, 'Failed to delete expense');
    }
  };

  const onChange = async (item, refresh = false) => {
    try {
      await item.submit();
      if (refresh) {
        await refreshOnboardingStepCollection();
      }
    } catch (err) {
      displayErrorMessageWithChecks(err, displayErrorMessage, 'Failed to edit expense');
    }
  };

  return (
    <FDPaper
      width={'100%'}
    >
      <FDStack direction={'column'}>
        {
            items.map((item, i) => {
              return (
                <FDBox key={item.id()}>
                  <MetaResourceRenderer
                    resource={item}
                    layout={RecurringExpenseItemComponent}
                    metaOverrideSet={RecurringExpenseItemOverride}
                    LayoutProps={{
                      onDelete,
                      onBlur: onChange,
                    }}
                  />
                  {i !== (items.length - 1)
                    ? <hr style={{
                      border: 'none',
                      backgroundColor: `${theme.palette.facet.stone600}`,
                      margin: '0px',
                      height: '1px',
                      width: '100%',
                    }}
                    /> : null }
                </FDBox>);
            })
          }
      </FDStack>
    </FDPaper>
  );
}

RecurringExpenseItems.propTypes = {
  items: PropTypes.arrayOf(fr.Resource).isRequired,
  RecurringExpenseItemComponent: PropTypes.object.isRequired,
};

RecurringExpenseItems.defaultProps = {
};

export default RecurringExpenseItems;
